import { Fragment, h } from 'preact';
import { UI_SKIP_INTRO_CLICKED, UI_SKIP_RECAP_CLICKED } from '../../../../store/types';
import { COMING_NEXT, NEXT, USER_REQUEST_MEDIA_LOAD } from '../../../../types';
import { usePlayerContext } from '../../../common/hooks';
import { mapTitleMetadata } from '../../../common/utils/tools';
import { connect, withBreakPoints } from '../../hoc';
import { SKIP_BTN_INTRO_OVERRIDE } from '../common/buttons/styles';
import { SkipButton } from '../controls';
import FeedbackOverlays from '../feedback/FeedbackOverlay';
import { PIPView } from '../info';
import Spinner from '../spinner';
import Warning from '../warning';
import TapLayer from './TapLayer';

function SectionOverlay({
  waitStart,
  handleTap,
  containerVisible,
  forceHidden,
  mobile,
  extraSmall,
  isAd,
  skipIntroDuration,
  skipIntroTimeCode,
  showSkipIntro,
  showSkipRecap,
  skipRecapDuration,
  skipRecapTimeCode,
  showComingNext,
  next,
  playlist,
  showNextPlaylistBtn,
  currentPlaylistVideo,
  title,
  preTitle,
  additionalTitle,
  hasDialogOpened
}) {
  const player = usePlayerContext();
  const getNextClickEvent = (isNext, isPlaylist) => {
    if (isNext) {
      return { name: NEXT, payload: COMING_NEXT };
    }

    if (isPlaylist) {
      const nextPlaylistVideo = currentPlaylistVideo + 1;
      const tracking = {
        /* position is the human readable version of the index, hence the +1 */
        diffusion: { mode: 'tunnel', position: nextPlaylistVideo + 1, length: playlist.length },
        tracking: {
          pageProvenance: '',
          zoneProvenance: 'playlist_player',
          positionVignette: '',
          playProvenance: 'tunnel_comingnext'
        },
        startTimecode: 0,
        ...mapTitleMetadata(playlist[nextPlaylistVideo], { title, preTitle, additionalTitle })
      };
      return {
        action: USER_REQUEST_MEDIA_LOAD,
        value: {
          from: 'coming_next',
          src: playlist[nextPlaylistVideo].src,
          config: {
            ...playlist[nextPlaylistVideo].config,
            intro: false,
            autostart: true,
            ...tracking
          }
        }
      };
    }
    return {};
  };
  return (
    <Fragment>
      <PIPView />
      <TapLayer
        /* TapLayer handles initial click to start player in autostart: false
        * and "tap to hide UI" behavior on mobile devices */
        isMobile={mobile}
        ariaLabel="lecture"
        onTap={waitStart ? () => player.play({ userGesture: true }) : handleTap}
        visible={(waitStart || (mobile && !containerVisible)) && !forceHidden}
      />
      <Spinner />
      <Warning />
      <FeedbackOverlays hasDialogOpened={hasDialogOpened} />
      {(!extraSmall && !isAd && (
        <SkipButton
          duration={skipIntroDuration}
          timecode={skipIntroTimeCode}
          label="Passer le générique"
          show={showSkipIntro}
          style={SKIP_BTN_INTRO_OVERRIDE}
          clickEvent={UI_SKIP_INTRO_CLICKED}
        />
      ))}
      {(!extraSmall && !isAd && (
        <SkipButton
          duration={skipRecapDuration}
          timecode={skipRecapTimeCode}
          label="Passer le récap"
          show={showSkipRecap}
          clickEvent={UI_SKIP_RECAP_CLICKED}
        />
      ))}
      {(!extraSmall && !isAd && (next || showNextPlaylistBtn) && (
        <SkipButton
          label="Vidéo suivante"
          show={showComingNext}
          clickEvent={getNextClickEvent(next, showNextPlaylistBtn)}
          seek={false}
        />
      ))}
    </Fragment>
  );
}

const selector = ({
  playlist: { playlist, playlistEnabled = Boolean(playlist.length) },
  ui: {
    comingNextVisible,
    isFullscreen,
    forceHidden,
    hasDialogOpened
  },
  media: { isAd, id, title, preTitle, additionalTitle },
  media: {
    skipIntro: { timecode: skipIntroTimeCode, duration: skipIntroDuration },
    skipRecap: { timecode: skipRecapTimeCode, duration: skipRecapDuration }
  },
  ui: { showSkipIntro, showSkipRecap, showComingNext, next }
}) => ({
  forceHidden,
  isAd,
  isFullscreen,
  comingNextVisible,
  skipIntroDuration,
  skipIntroTimeCode,
  showSkipIntro,
  showSkipRecap,
  skipRecapDuration,
  skipRecapTimeCode,
  showComingNext,
  next,
  playlist,
  showNextPlaylistBtn: playlistEnabled && playlist[playlist.length - 1].src !== id,
  currentPlaylistVideo: playlist.findIndex((v) => v.src === id),
  title,
  preTitle,
  additionalTitle,
  hasDialogOpened
});

export default withBreakPoints(connect(selector)(SectionOverlay));
